import antMessage, { type ArgsProps as MessageArgsProps } from "antd/lib/message";

// Create custom config for info type
const customConfig: Partial<MessageArgsProps> = {
    className: "[&_.anticon>svg]:fill-[#504DC1]",
};

// Create enhanced message object with customized info method
export const message = {
    ...antMessage,
    info: (content: string, config?: MessageArgsProps) =>
        antMessage.info({ ...customConfig, ...(config || {}), content }),
};
